/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/css/common/cssWorker.nls.ru", {
	"vs/languages/css/common/cssWorker": [
		"@keyframes {0}",
		"@font-face",
		"Переименовать в \"{0}\"",
	],
	"vs/languages/css/common/parser/cssErrors": [
		"ожидается число",
		"ожидается условие",
		"ожидается at-правило или селектор",
		"ожидается точка",
		"ожидается двоеточие",
		"ожидается точка с запятой",
		"ожидается термин",
		"ожидается выражение",
		"ожидается оператор",
		"ожидается идентификатор",
		"ожидается процент",
		"ожидается универсальный код ресурса (URI) или строка",
		"ожидается универсальный код ресурса (URI)",
		"ожидается имя переменной",
		"ожидается значение переменной",
		"ожидается значение свойства",
		"ожидается \"{\"",
		"ожидается \"}\"",
		"ожидается \"[\"",
		"ожидается \"]\"",
		"ожидается \"(\"",
		"ожидается \")\"",
		"ожидается запятая",
		"ожидается директива или объявление страницы",
		"неизвестное at-правило",
		"неизвестное ключевое слово",
		"ожидается селектор",
		"ожидается строковый литерал",
	],
	"vs/languages/css/common/services/intelliSense": [
		"Создает цвет на основании значений красного, зеленого и синего цветов.",
		"Создает цвет на основании значений красного, зеленого, синего цветов и альфа-фактора.",
		"Создает цвет на основании значений оттенка, насыщенности и освещенности.",
		"Создает цвет на основании значений оттенка, насыщенности, освещенности и альфа-фактора.",
	],
	"vs/languages/css/common/services/lint": [
		"\"{0}\"",
		"{0}, \"{1}\"",
		"Всегда определяйте стандартное правило \"@keyframes\" при определении ключевых кадров.",
		"Всегда включайте все зависящие от поставщиков правила. Отсутствует: {0}",
		"Также для совместимости определяйте стандартное свойство \"{0}\"",
		"Всегда включайте все зависящие от поставщиков свойства. Отсутствует: {0}",
	],
	"vs/languages/css/common/services/lintRules": [
		"При использовании зависящего от поставщика префикса также указывайте все остальные свойства поставщика",
		"При использовании зависящего от поставщика префикса также указывайте стандартное свойство",
		"Не использовать дублирующиеся определения стилей",
		"Не использовать пустые наборы правил",
		"Операторы импорта не загружаются параллельно",
		"Не использовать ширину или высоту при использовании поля или границы",
		"Универсальный селектор (*), как известно, функционирует медленно",
		"Для нуля не требуется никакой единицы",
		"Правило @font-face должно определять свойства \"src\" и \"font-family\"",
		"Цвета в шестнадцатеричном формате должны содержать три или шесть шестнадцатеричных чисел",
		"Недопустимое число параметров",
		"Неизвестное свойство.",
		"Полезные советы для Internet Explorer требуются только при поддержке Internet Explorer 7 и более ранних версий",
		"Неизвестное свойство поставщика.",
		"Свойство проигнорировано из-за значения свойства display. Например, при \"display: inline\" свойства width, height, margin-top, margin-bottom и float не работают",
		"Старайтесь не использовать !important, так как это признак того, что весь код CSS стал неуправляемым и его надо переработать.",
		"Старайтесь не использовать \"float\". Из-за элементов \"float\" работа кода CSS может легко нарушиться, если изменить один из аспектов разметки.",
		"Селекторы не должны содержать идентификаторов, потому что эти правила слишком тесно связаны с HTML.",
		"Включает или отключает все проверки",
	]
});